import store from "@/store";
import request from "@/utils/request";

export async function getShortUrlList(params) {
    console.log("@@ get list : getShortUrlList");
    let result = request.get("/api/marketing/short_url/",{params});
    return result;
}
export async function getShortUrlDetail(params) {
    console.log("@@ get list : getShortUrlDetail");
    let result = request.get("/api/marketing/short_url/detail/",{params});
    return result;
}

export async function saveShortUrl(params) {
    console.log("@@ post save : saveShortUrl");
    let result = request.post(`/api/marketing/short_url/save/`,params);
    return result;
}

export async function deleteShortUrl(params) {
    console.log("@@ get list : deleteShortUrl");
    let result = request.post("/api/marketing/short_url/delete/",params);
    return result;
}

Date.prototype.yyyymmdd = function() {
  let yyyy = this.getFullYear().toString();
  let mm = (this.getMonth() + 1).toString();
  let dd = this.getDate().toString();
  let hh = this.getHours().toString();
  let min = this.getMinutes().toString();
  return yyyy + (mm[1]?mm:'0'+mm[0]) + (dd[1]?dd:'0'+dd[0]) + (hh[1]?hh:'0'+hh[0]) + (min[1]?min:'0'+min[0]);
}

export async function clickStatExcelDownload(params, fileName) {
    console.log("@@ get list: clickStatExcelDownload");
    const url = process.env.VUE_APP_ADM_API+"/api/marketing/short_url/excel/download";
    request.get(url, {
        params: params,
        responseType: "blob"
    })
    .then(response => {
        console.log(response);
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(response);
        a.href = url;
        let date = new Date();
        a.download = fileName+'_'+date.yyyymmdd()+'.xlsx';
        a.click();
    })
    .catch(err => {
        console.log("error", err);
    })
}
